import React, {useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles, Collapse, Typography, IconButton, } from "@material-ui/core";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import SaveIcon from '@material-ui/icons/Save';
import LocationForm from "./LocationForm";
import t from "../../../languages/pl";

const useStyles = theme => ({
    addNewLabel: {
        display: "flex",
        justifyContent: 'space-between',
        alignItems: "center",
        paddingLeft: theme.spacing(2)
    },
    collapseContainer: {
        border: "1px solid",
        borderRadius: 10,
        borderColor: "lightgrey",
        position: "relative"
    },
    collapseContent: {
        display: "flex",
    },
    buttonsBar: {
        position: "absolute",
        top: 60,
        right: 0,
        display: "flex",
        flexDirection: "column"
    }
});

const AddPoi = props => {
    const { classes, onSearch, onAdd, isNewOpen, onExpandAddPoi } = props;
    const formRef = useRef();
    const [updatedData, setUpdatedData] = useState(initialState);

    const handleSearch = (data) => {
        onSearch && onSearch(data.adres);
    };

    const handleSave = (data) => {
        onAdd(data);
    };

    const handleChange = (data) => {
        setUpdatedData(data);
    };

    return (
        <Collapse
            in={isNewOpen}
            collapsedHeight={50}
            classes={{ container: classes.collapseContainer }}
        >
            <div className={classes.addNewLabel}>
                <Typography variant="subtitle1">
                    {t.addPoi}
                </Typography>
                <IconButton onClick={onExpandAddPoi}>
                    {isNewOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </IconButton>
            </div>
            <LocationForm
                ref={formRef}
                onSave={handleSave}
                onSearch={handleSearch}
                onChange={handleChange}
            />
            <div className={classes.buttonsBar}>
                <IconButton
                    disabled={updatedData.nazwa === "" || updatedData.adres === "" || updatedData.typ === "" }
                    onClick={() => formRef.current.dispatchEvent(new Event("save"))}
                >
                    <SaveIcon />
                </IconButton>
            </div>
        </Collapse>
    );
};

const initialState = {
    nazwa: "",
    adres: "",
    typ: ""
};

AddPoi.propTypes = {
    classes: PropTypes.object,
    onSearch: PropTypes.func,
    onAdd: PropTypes.func,
    isNewOpen: PropTypes.bool,
    onExpandAddPoi: PropTypes.func,
};

export default withStyles(useStyles)(AddPoi);
